var _path, _rect;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgVolumeRecomendado = function SvgVolumeRecomendado(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 2.08105H5.75C5.05977 2.08105 4.5 2.64082 4.5 3.33105V5.83105C4.5 6.52129 5.05977 7.08105 5.75 7.08105V19.8936C5.75 21.1006 6.73164 22.0811 7.9375 22.0811H16.0625C17.2688 22.0811 18.25 21.0998 18.25 19.8936V7.08105C18.9402 7.08105 19.5 6.52129 19.5 5.83105V3.33105C19.5 2.64082 18.9414 2.08105 18.25 2.08105ZM6.375 3.95605H17.625V5.20605H6.375V3.95605ZM16.375 19.8936C16.375 20.0657 16.2346 20.2061 16.0625 20.2061H7.9375C7.76539 20.2061 7.625 20.0657 7.625 19.8936V18.3311H9.8125C10.332 18.3311 10.75 17.9131 10.75 17.3936C10.75 16.874 10.332 16.4561 9.8125 16.4561H7.625V14.5811H9.8125C10.332 14.5811 10.75 14.1631 10.75 13.6436C10.75 13.124 10.332 12.7061 9.8125 12.7061H7.625V10.8311H9.8125C10.332 10.8311 10.75 10.4131 10.75 9.89355C10.75 9.37402 10.332 8.95605 9.8125 8.95605H7.625V7.08105H16.375V19.8936Z",
    fill: "#003087"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 16.0811,
    width: 11,
    height: 5,
    fill: "#003087"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVolumeRecomendado, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volumeRecomendado.2dd49e47.svg";
export { ForwardRef as ReactComponent };